import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between text-gray-950 text-xs font-500 border-b" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center item py-4"
}
const _hoisted_3 = { class: "d-flex align-center item py-4" }
const _hoisted_4 = { class: "d-flex align-center item py-4" }
const _hoisted_5 = { class: "d-flex align-center item py-4" }
const _hoisted_6 = { class: "d-flex align-center item py-4" }
const _hoisted_7 = { class: "d-flex align-center item py-4" }
const _hoisted_8 = { class: "d-flex align-center item py-4" }
const _hoisted_9 = { class: "d-flex align-center item py-4" }
const _hoisted_10 = { class: "d-flex justify-space-between text-gray-950 text-xs font-500 border-b" }
const _hoisted_11 = { class: "d-flex align-center item py-4" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-center item py-4"
}
const _hoisted_13 = { class: "d-flex align-center item py-4" }
const _hoisted_14 = { class: "d-flex align-center item py-4" }
const _hoisted_15 = { class: "d-flex align-center item py-4" }
const _hoisted_16 = { class: "d-flex align-center item py-4" }
const _hoisted_17 = { class: "d-flex align-center item py-4" }
const _hoisted_18 = { class: "d-flex align-center item py-4" }

import { computed } from 'vue';
import * as comps from '@/components/atoms';
import type { IMetasOnlyTooltip, IMetasTooltip } from '@/types'

interface IProps {
  items: IMetasTooltip[];
  itemsOnly: IMetasOnlyTooltip[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTooltipMetas',
  props: {
    items: {},
    itemsOnly: {}
  },
  setup(__props: any) {

const props = __props

const isMeta = computed(() => {
  return props.items.length != 0
})

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "close-on-content-click": false,
    width: 384,
    "open-on-hover": ""
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(comps.AtomButton, _mergeProps({
        background: "dark",
        "no-hover": "",
        class: "d-flex align-center cursor-pointer pa-0"
      }, props, { style: {"width":"100%"} }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, { style: {"border-radius":"16px"} }, {
        default: _withCtx(() => [
          (isMeta.value)
            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (props.items.some(f => !!f.role))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                          _createTextVNode("Função "),
                          (_openBlock(), _createBlock(_resolveDynamicComponent(comps.ChevronSolidIcon), { class: "rotate-invert" }))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_3, [
                      _createTextVNode("Nome "),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(comps.ChevronSolidIcon), { class: "rotate-invert" }))
                    ]),
                    _createElementVNode("p", _hoisted_4, [
                      _createTextVNode("Comissionamento "),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(comps.ChevronSolidIcon), { class: "rotate-invert" }))
                    ]),
                    _createElementVNode("p", _hoisted_5, [
                      _createTextVNode("% "),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(comps.ChevronSolidIcon), { class: "rotate-invert" }))
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${idx}-m`,
                      class: _normalizeClass(["d-flex justify-space-between text-gray-500 text-xs font-500", `${idx !== props.items.length - 1 && 'border-b'}`])
                    }, [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(item.role), 1),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(item.name), 1),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(item.margin), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(item.percent), 1)
                    ], 2))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_list_item, { key: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, [
                      _createTextVNode("Meta "),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(comps.ChevronSolidIcon), { class: "rotate-invert" }))
                    ]),
                    (props.items.some(f => !!f.installment))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                          _createTextVNode("Parcela "),
                          (_openBlock(), _createBlock(_resolveDynamicComponent(comps.ChevronSolidIcon), { class: "rotate-invert" }))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_13, [
                      _createTextVNode("Comissionamento "),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(comps.ChevronSolidIcon), { class: "rotate-invert" }))
                    ]),
                    _createElementVNode("p", _hoisted_14, [
                      _createTextVNode("% "),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(comps.ChevronSolidIcon), { class: "rotate-invert" }))
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.itemsOnly, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${idx}-m`,
                      class: _normalizeClass(["d-flex justify-space-between text-gray-500 text-xs font-500", `${idx !== props.items.length - 1 && 'border-b'}`])
                    }, [
                      _createElementVNode("p", _hoisted_15, _toDisplayString(item.goal), 1),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(item.installment), 1),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(item.margin), 1),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(item.percent), 1)
                    ], 2))
                  }), 128))
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})